import React, { useEffect, useState, useMemo } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  useToast,
  Textarea,
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Tooltip,
  IconButton,
  AlertDialog,
  AlertDialogOverlay,
  AlertDialogContent,
  AlertDialogCloseButton,
  AlertDialogFooter,
  AlertDialogBody,
  AlertDialogHeader,
  useDisclosure,
  Spacer,
} from '@chakra-ui/react';
import { AppDispatch, Store } from '../Store/StoreInit';
import axios from 'axios';
import {
  IHealthPlanMappingItem,
  IInscoItem,
} from '../Infrastructure/Interfaces';
import { useDispatch, useSelector } from 'react-redux';
import useTable from '../TablePagination/UseTable';
import TablePagination from '../TablePagination/TablePagination';
import { ImBin } from 'react-icons/im';
import { fetchIdentifierInscoList } from '../Store/ScenariosReducer';
import { useMsal } from '@azure/msal-react';

interface Props {
  isOpen?: any;
  onOpen?: any;
  onClose?: any;
}

const IdentifiersModalPopup: React.FC<Props> = (props: Props) => {
  const rawInscoList: IInscoItem[] = useSelector(
    (state: any) => state.IdentifierInscoReducer.inscoList.inscoList
  );
  const inscolist: IInscoItem[] = useMemo(() => rawInscoList, [rawInscoList]);
  const [TableFilter, setTableFilter] = useState<IInscoItem[]>([]);

  useEffect(() => {
    setIsIdentifierReq(false);
    if (inscolist) {
      setTableFilter(inscolist);
    }
  }, [inscolist]);

  const dispatch = useDispatch<AppDispatch>();
  const [saveButtonLoading, setSaveButtonLoading] = useState(false);
  const [value, setValue] = useState('');
  //const [TableFilter, setTableFilter] = useState(inscolist);
  const [currentPage, setCurrentPage] = useState(1);
  const claimsPerPage = 10;
  const lastIndex = currentPage * claimsPerPage;
  const firstIndex = lastIndex - claimsPerPage;
  var datasource: IInscoItem[] = Array.isArray(inscolist)
    ? inscolist.slice(firstIndex, lastIndex)
    : [];
  var { slice, range } = useTable(
    value.length > 0 ? TableFilter : inscolist ? inscolist : [],
    currentPage,
    claimsPerPage
  );
  const toast = useToast();
  const scenarioid = Store.getState().setScenariosItem.value.scenarioid;
  const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
  const userrole =
    userdetails[0].userRole != '' ? userdetails[0].userRole : 'User';
  const [isIdentifierReq, setIsIdentifierReq] = useState(false);
  const {
    isOpen: isDeleteModalOpen,
    onOpen: onDeleteModalOpen,
    onClose: onDeleteModalClose,
  } = useDisclosure();
  const cancelRef = React.useRef(null);
  const [deleteOkLoading, setDeleteOkLoading] = useState(false);
  const [toBeDeletedItem, setToBeDeleteItem] = useState<IInscoItem>();
  const healthplanlistitems: IHealthPlanMappingItem[] = useSelector(
    (state: any) => {
      return state.healthPlanPayerMappedList.healthPlanMappingList;
    }
  );
  const { accounts } = useMsal();
  const userid =
    userdetails[0].portal_Id != ''
      ? userdetails[0].portal_Id
      : accounts[0].username;

  const filterData = (e: any) => {
    if (e.target.value !== '') {
      setValue(e.target.value);
      const filterTable = inscolist.filter(o =>
        Object.keys(o).some(k =>
          String(o[k as keyof IInscoItem])
            .toLowerCase()
            .includes(e.target.value.toLowerCase())
        )
      );
      setTableFilter([...filterTable]);
      datasource = TableFilter;
    } else {
      setValue(e.target.value);
      setTableFilter(inscolist);
    }
  };

  const [data, setdata] = useState({
    scenarioid: 0,
    documentid: 0,
    variationid: 0,
    name: '',
    billing_admin: '',
    billing_system: '',
    billing_client: '',
    chart_required: false,
    eob_required: false,
    claim_required: false,
    deliver_option: '',
    deliver_regard: '',
    deliver_to_email_address: '',
    fax_to: '',
    fax_to_faxnumber: '',
    fax_user: '',
    fax_secret: '',
    requestor_first_name: '',
    requestor_last_name: '',
    requestor_phone: '',
    requestor_fax: '',
    requestor_email_address: '',
    requestor_signature: '',
    requestor_company_name: '',
    requestor_company_address1: '',
    requestor_company_address2: '',
    requestor_company_city: '',
    requestor_company_state: '',
    requestor_company_zip: '',
    requestor_alternate_contact: '',
    page_limit: '',
    next_delivery: '',
    upload_channel: '',
    default_channel: false,
  });

  useEffect(() => {
    Store.subscribe(() => {
      setValue('');
      setdata({
        ...data,
        scenarioid: Store.getState().setScenariosItem.value.scenarioid,
        documentid: Store.getState().setScenariosItem.value.documentid,
        variationid: Store.getState().setScenariosItem.value.variationid,
        name: Store.getState().setScenariosItem.value.name,
        billing_admin: Store.getState().setScenariosItem.value.billing_admin,
        billing_system: Store.getState().setScenariosItem.value.billing_system,
        billing_client: Store.getState().setScenariosItem.value.billing_client,
        chart_required: Store.getState().setScenariosItem.value.chart_required,
        eob_required: Store.getState().setScenariosItem.value.eob_required,
        claim_required: Store.getState().setScenariosItem.value.claim_required,
        deliver_option: Store.getState().setScenariosItem.value.deliver_option,
        deliver_regard: Store.getState().setScenariosItem.value.deliver_regard,
        deliver_to_email_address:
          Store.getState().setScenariosItem.value.deliver_to_email_address,
        fax_to: Store.getState().setScenariosItem.value.fax_to,
        fax_to_faxnumber:
          Store.getState().setScenariosItem.value.fax_to_faxnumber,
        fax_user: Store.getState().setScenariosItem.value.fax_user,
        fax_secret: Store.getState().setScenariosItem.value.fax_secret,
        requestor_first_name:
          Store.getState().setScenariosItem.value.requestor_first_name,
        requestor_last_name:
          Store.getState().setScenariosItem.value.requestor_last_name,
        requestor_phone:
          Store.getState().setScenariosItem.value.requestor_phone,
        requestor_fax: Store.getState().setScenariosItem.value.requestor_fax,
        requestor_email_address:
          Store.getState().setScenariosItem.value.requestor_email_address,
        requestor_signature:
          Store.getState().setScenariosItem.value.requestor_signature,
        requestor_company_name:
          Store.getState().setScenariosItem.value.requestor_company_name,
        requestor_company_address1:
          Store.getState().setScenariosItem.value.requestor_company_address1,
        requestor_company_address2:
          Store.getState().setScenariosItem.value.requestor_company_address2,
        requestor_company_city:
          Store.getState().setScenariosItem.value.requestor_company_city,
        requestor_company_state:
          Store.getState().setScenariosItem.value.requestor_company_state,
        requestor_company_zip:
          Store.getState().setScenariosItem.value.requestor_company_zip,
        requestor_alternate_contact:
          Store.getState().setScenariosItem.value.requestor_alternate_contact,
        page_limit: Store.getState().setScenariosItem.value.page_limit,
        next_delivery: Store.getState().setScenariosItem.value.next_delivery,
        upload_channel: Store.getState().setScenariosItem.value.upload_channel,
        default_channel:
          Store.getState().setScenariosItem.value.default_channel,
      });
    });
  }, []);

  function deleteItemDialog(item: IInscoItem) {
    setToBeDeleteItem(item);
    onDeleteModalOpen();
  }

  async function deleteItem(item: IInscoItem) {
    var mappedPlan = healthplanlistitems.find(
      x => x.scenarioId == item.scenarioid && x.healthPlanName == item.insco
    );

    if (mappedPlan) {
      if (Array.isArray(mappedPlan)) {
        mappedPlan.forEach(async t => {
          const tokenurl = process.env.REACT_APP_TOKEN_URL_SIS as string;
          const baseurl = process.env.REACT_APP_SERVER_BASE_URL as string;
          const url: string =
            baseurl +
            '/Payer/delete_healthplanmapping' +
            '?healthplanmappingid=' +
            t.healthPlanMappingId +
            '&userid=' +
            userid + '&user=' + accounts[0].username;

          await axios.get(tokenurl).then(async res => {
            if (res.data.success) {
              await axios
                .delete(url, {
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + res.data.token,
                  },
                })
                .then(async response => {
                  if (response.data.success) {
                    deleteInsco(item);
                  }
                })
                .catch(error => {
                  showToast(
                    'Error!',
                    error.response.data.message || error.message,
                    'error'
                  );
                });
            }
          });
        });
      }
    } else {
      deleteInsco(item);
    }
  }

  async function deleteInsco(item: IInscoItem) {
    setDeleteOkLoading(true);
    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;
    const url: string = `${baseurl}/Appeal/delete_insco?inscoid=${item.inscoid}&user=${accounts[0].username}`;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const response = await axios.post(url, null, {
          headers: {
            Pragma: 'no-cache',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        if (response.data.success) {
          showToast('Success', `${item.insco} deleted successfully`, 'success');
          onDeleteModalClose();
          dispatch(fetchIdentifierInscoList(item.scenarioid));
        }
      }
    } catch (error: any) {
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
      onDeleteModalClose();
    } finally {
      setDeleteOkLoading(false);
    }
  }

  async function handleSubmit(e: { preventDefault: () => void }) {
    e.preventDefault();
    if (value.trim() === '') {
      setIsIdentifierReq(true);
      return;
    }

    var inscodata: IInscoItem | undefined = inscolist.find(
      x => x.insco == value.trim()
    );
    if (inscodata) {
      showToast('Info!', value + ' Already exists', 'info');
      return;
    }

    setSaveButtonLoading(true);
    const data = {
      scenarioid: scenarioid,
      inscoid: 0,
      insco: value.trim(),
    };

    const tokenurl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    const baseurl = process.env.REACT_APP_SERVER_SCENARIOS_BASE_URL as string;

    try {
      const res = await axios.get(tokenurl);
      if (res.data.success) {
        const url = `${baseurl}/Appeal/add_insco`;
        const response = await axios.post(url, JSON.stringify(data), {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${res.data.token}`,
          },
        });

        setSaveButtonLoading(false);
        //dispatch(fetchSceneriosList());
        dispatch(fetchIdentifierInscoList(scenarioid));
        //props.onClose();

        if (response.data.success) {
          setValue('');
          showToast('Success', response.data.message, 'success');
        }
      }
    } catch (error: any) {
      setSaveButtonLoading(false);
      showToast(
        'Error!',
        error.response.data.message || error.message,
        'error'
      );
    }
  }

  function showToast(
    title: string,
    description: string,
    status: 'error' | 'success' | 'warning' | 'info'
  ) {
    toast({
      title,
      description,
      position: 'top',
      status,
      duration: status === 'error' ? 20000 : 10000,
      isClosable: true,
    });
  }

  return (
    <>
      <Modal
        closeOnOverlayClick={false}
        size={'6xl'}
        isOpen={props.isOpen}
        onClose={props.onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit}>
            <ModalHeader fontWeight="bold" textAlign="center" fontSize="16px">
              {`${data.name}`} Identifiers
            </ModalHeader>
            <ModalCloseButton color="black" />{' '}
            <ModalBody>
              <FormControl mt={2} isRequired isInvalid={isIdentifierReq}>
                <FormLabel fontSize="16px" fontWeight="bold">
                  Identifier:
                </FormLabel>
                <Textarea
                  size="sm"
                  placeholder="identifier"
                  name="identifier"
                  id="identifier"
                  value={value}
                  onChange={filterData}
                />
              </FormControl>

              <Button
                mt={4}
                alignContent="right"
                isLoading={saveButtonLoading}
                bg="#002677"
                color="white"
                mr={3}
                type="submit"
                isDisabled={true}
              >
                Save Identifier
              </Button>

              <Box mt={4}>
                <TableContainer borderRadius="5px" borderTopColor="black">
                  <Table
                    variant="striped"
                    colorScheme="blackAlpha"
                    size="xs"
                    overflow="Auto"
                  >
                    <Thead bgColor="#002677">
                      <Tr>
                        <Th fontSize="xs" color="white">
                          INSCO
                        </Th>
                        {userrole.toUpperCase() != 'USER' ? (
                          <Th fontSize="xs" color="white" pr="10px" isNumeric>
                            ACTIONS
                          </Th>) : ''
                        }
                      </Tr>
                    </Thead>
                    <Tbody>
                      {value.length > 0
                        ? TableFilter?.slice(firstIndex, lastIndex).map(
                            item => {
                              return (
                                <Tr
                                  key={item.inscoid}
                                  style={{ fontSize: '14px' }}
                                >
                                  <>
                                    <Td whiteSpace="pre">{item.insco}</Td>
                                    {userrole.toUpperCase() != 'USER' ? (
                                      <Td
                                        pt="0"
                                        pb="0"
                                        mt="0"
                                        mb="0"
                                        isNumeric
                                        pr="25px"
                                      >
                                        <Tooltip
                                          hasArrow
                                          label="Delete Insco"
                                          bg="grey.300"
                                          color="black"
                                        >
                                          <IconButton
                                            size="xs"
                                            ml={4}
                                            bg="none"
                                            aria-label="Delete"
                                            icon={<ImBin />}
                                            onClick={() => deleteItemDialog(item)}
                                          />
                                        </Tooltip>
                                      </Td>
                                    ) : (
                                      ''
                                    )}
                                  </>
                                </Tr>
                              );
                            }
                          )
                        : datasource?.map(item => {
                            return (
                              <Tr
                                key={item.inscoid}
                                style={{ fontSize: '14px' }}
                              >
                                <>
                                  <Td whiteSpace="pre">{item.insco}</Td>
                                  {userrole.toUpperCase() != 'USER' ? (
                                    <Td
                                      pt="0"
                                      pb="0"
                                      mt="0"
                                      mb="0"
                                      isNumeric
                                      pr="25px"
                                    >
                                      <Tooltip
                                        hasArrow
                                        label="Delete Insco"
                                        bg="grey.300"
                                        color="black"
                                      >
                                        <IconButton
                                          size="xs"
                                          ml={4}
                                          bg="none"
                                          aria-label="Delete"
                                          icon={<ImBin />}
                                          onClick={() => deleteItemDialog(item)}
                                        />
                                      </Tooltip>
                                    </Td>
                                  ) : (
                                    ''
                                  )}
                                </>
                              </Tr>
                            );
                          })}
                    </Tbody>
                  </Table>
                  <TablePagination
                    range={range}
                    slice={slice}
                    setPage={setCurrentPage}
                    page={currentPage}
                  />
                </TableContainer>
              </Box>
            </ModalBody>
          </form>
        </ModalContent>
      </Modal>
      <AlertDialog
        motionPreset="scale"
        isOpen={isDeleteModalOpen}
        leastDestructiveRef={cancelRef}
        onClose={onDeleteModalClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Delete Insco?
            </AlertDialogHeader>
            <AlertDialogCloseButton color="black" />
            <AlertDialogBody>
              Are you sure you want to delete <b>{toBeDeletedItem?.insco}</b> ?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                bg="#002677"
                color="white"
                onClick={onDeleteModalClose}
                ml={3}
              >
                Cancel
              </Button>
              <Spacer />
              <Button
                isLoading={deleteOkLoading}
                bg="#002677"
                color="white"
                ref={cancelRef}
                onClick={() => deleteItem(toBeDeletedItem!)}
              >
                Delete
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default IdentifiersModalPopup;
